import slugify from './slugify';
import appendUTMParams from './utmParams';

const categoryUrl = category => {
  const url = ['/find'];

  if (category) {
    url.push(`${slugify(category)}`);
    return appendUTMParams(url.join('/'));
  }

  return null;
};

export default categoryUrl;
